module.exports = __webpack_public_path__ + "img/quizz_candidate.ed6b9e01.jpeg";